import { Radio } from '@insurgrid/common';
import { RadioGroup as HUIRadioGroup } from '@headlessui/react';
import classNames from 'classnames';
import { useFormFieldState } from './hooks';
import { UseFormRegister } from 'react-hook-form';

export function RadioGroup(
  props: {
    register?: UseFormRegister<any>;
  } & Radio,
) {
  const { formContext } = useFormFieldState({ name: props.name });
  const value = formContext.watch(props.name);

  return (
    <HUIRadioGroup
      value={value}
      onChange={(v) =>
        formContext.setValue(props.name, v, { shouldDirty: true })
      }
    >
      <HUIRadioGroup.Label className="text-gray-500 text-xs mb-1">
        {props.label}
      </HUIRadioGroup.Label>
      <div className="w-min space-y-2">
        {props.options.map((o, i) => (
          <HUIRadioGroup.Option
            key={`${o.label}-${o.value}-${o.selectorType}`}
            value={o.value}
          >
            {({ active, checked }) => (
              <div
                className={classNames(
                  'flex items-center space-x-3 border rounded-md hover:shadow-md cursor-pointer w-full whitespace-nowrap px-2 py-1 transition-all',
                  active || checked ? 'border-blue' : 'border-gray-200',
                )}
              >
                <div
                  className={classNames(
                    'h-4 w-4 transition-all rounded-full border flex items-center justify-center cursor-pointer',
                    active && 'ring-blue-500 ring-1 ring-offset-1',
                    value === o.value
                      ? 'bg-blue border-transparent'
                      : 'bg-white border-gray-400',
                  )}
                >
                  <span className="block bg-white rounded-full h-1.5 w-1.5" />
                </div>
                <HUIRadioGroup.Label
                  as="span"
                  className="text-sm whitespace-nowrap cursor-pointer mt-[0.22rem]"
                >
                  {o.label}
                </HUIRadioGroup.Label>
              </div>
            )}
          </HUIRadioGroup.Option>
        ))}
      </div>
    </HUIRadioGroup>
  );
}
